import { render } from "./SCodeEditor.vue?vue&type=template&id=7de62cc5&ts=true"
import script from "./SCodeEditor.ts?vue&type=script&lang=ts"
export * from "./SCodeEditor.ts?vue&type=script&lang=ts"

import "./SCodeEditor.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__